import { combineReducers } from 'redux';
import authReducer from './authReducer';
import faqReducer from './faqReducer';

const rootReducer = combineReducers({
  auth: authReducer, // Handles authentication-related state
  faq: faqReducer,   // Handles FAQ-related state
  // Add other reducers here as needed
});

export default rootReducer;
